import React, { useMemo } from 'react';

import { useTranslationContext } from '@/core/lib/translation/translation.context';
import type { CategoryOptionValueResult } from '@/core/types/donation';

interface DonationCriteriaProps {
  options: CategoryOptionValueResult[] | [];
}

const DonationCriteria: React.FC<DonationCriteriaProps> = ({ options }) => {
  const { t } = useTranslationContext(['common']);

  const criterionToExclude = ['dlc'];

  const render = useMemo(() => {
    if (options.length === 0) return null;

    const renderList: React.ReactNode[] = [];

    options.forEach(criterion => {
      if (!criterionToExclude.includes(criterion.name)) {
        renderList.push(
          <div key={criterion.name} className="mt-2 inline-flex gap-8 lg:mt-1">
            <p className="text-body-secondary w-1/3 text-content-primary md:w-fit md:max-w-28">{t(`options.${criterion.name}.label`, { ns: 'common' })}</p>
            <p className="text-body-secondary font-semibold text-content-primary">{t(`options.${criterion.name}.${criterion.value}`, { ns: 'common' })}</p>
          </div>,
        );
      }
    });

    return renderList;
  }, [options]);

  if (options.length === 0) {
    return null;
  }

  return (
    <section className="flex flex-col">
      <p className="text-body-primary font-semibold text-content-primary">{t('components.donation.details.criteria.title', { ns: 'common' })}</p>
      {render && <div className="inline-flex w-full flex-col md:flex-row md:gap-16">{render}</div>}
    </section>
  );
};

export default DonationCriteria;
